import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import logo from '../logo_blanche_kengroup.png';
import Navbar from './Navbar';
import LiveClock from './LiveClock';

const HeaderWrapper = styled.div`
  background-color: ${props => props.theme.primary};
  color: #fff;
  height: 160px;
  padding: 25px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

const Image = styled.img`
  justify-self: flex-start;
  align-items: center;
`;

const Time = styled.div`
  margin-right: 50px;
  line-height: 32px;
  font-weight: bold;
  text-transform: uppercase;
  justify-self: flex-end;
  font-family: 'volte_roundedregular', sans-serif;
  font-size: 36px;
`;

const Header = ({ clientToken, clubId }) => (
  <HeaderWrapper>
    <Image src={logo} alt="logo" />
    <Navbar clientToken={clientToken} clubId={clubId} />
    <Time>
      <LiveClock />
    </Time>
  </HeaderWrapper>
);

Header.propTypes = {
  clientToken: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx